import { Authority, useAppLayout } from "@dataone/lib";
import { Button, Layout } from "antd";
import { styled } from "styled-components";
import { useAuth } from "../../features/auth/contexts/auth.provider";
import { useLocation, useNavigate } from "react-router-dom";
import AnimatedBird from "../product-tour/AnimatedBird";
import {
  ChevronDoubleIcon,
  ClosedGateIcon,
  GalaxyStarIcon,
  OpenedGateIcon,
} from "@dataone/icons";
import { OneGateLogo_2Icon } from "@dataone/icons";
import AnimatedGate from "./AnimatedGate";

const { Header } = Layout;

const LayoutHeader = () => {
  const { isSmartSearchVisible, isResponseVisible } = useAppLayout();

  const location = useLocation();
  const navigate = useNavigate();

  const { user, isAuthenticated } = useAuth();

  const showSmartSearch = () => {
    if (!isSmartSearchVisible)
      useAppLayout.setState({ isSmartSearchVisible: true });
  };

  return (
    <StyledLayoutHeader>
      {(!(!isAuthenticated && !user) ||
        location.pathname.startsWith("/dashboard/view")) && (
          <Header>
            <StyledLayoutHeaderContent
              $isSubscribeVisible={!isAuthenticated && !user}
            >
              {!isAuthenticated && !user ? (
                <>
                  <span className="logo">
                    <OneGateLogo_2Icon />
                  </span>
                  <Button
                    onClick={() => navigate("/subscription")}
                    className="btn-subscribe"
                  >
                    Subscribe
                  </Button>
                </>
              ) : (
                <div className="logo-position">
                  <CalendarContainer></CalendarContainer>
                  {user?.groups[0] !== Authority.OG_GUEST && isAuthenticated && (
                    <SmartSearchTrigger>
                      <StyledGateIcon
                        isSmartSearchVisible={isSmartSearchVisible}
                        isResponseVisible={isResponseVisible}
                        onClick={showSmartSearch}
                      >
                        {isSmartSearchVisible && isResponseVisible ? (
                          // <OpenedGateIcon />
                          <GalaxyStarIcon />
                        ) : isSmartSearchVisible && !isResponseVisible ? (
                          <GalaxyStarIcon />
                        ) : (
                          <AnimatedGate />
                        )}
                      </StyledGateIcon>
                      {/* {!isSmartSearchVisible && (
                      <StyledIcon onClick={showSmartSearch}>
                        <ChevronDoubleIcon />
                      </StyledIcon>
                    )} */}
                    </SmartSearchTrigger>
                  )}
                </div>
              )}
              <StyledAnimatedLogoPlaceholder />
              <AnimatedBird />
            </StyledLayoutHeaderContent>
          </Header>
        )}
    </StyledLayoutHeader>
  );
};

export default LayoutHeader;

const StyledLayoutHeader = styled.div`
  .ant-layout-header {
    // height: 90px;
    height: 70px;
    padding: 0;
    background: #fff;
    background: #eff1fd;
    position: relative;
    // border-bottom: 3px solid #eee;
  }
  .btn-collapse {
    position: absolute;
    z-index: 1001;
    left: -16px;
    top: 73px;
    font-size: 16px;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    padding-block: 2px;
    &,
    &:hover {
      color: #fff !important;
      background-color: #4974f6 !important;
      z-index: 1;
    }
  }
  .logo {
    font-size: 148px;
    display: flex;
  }
`;

const StyledLayoutHeaderContent = styled.div<{ $isSubscribeVisible: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 30px;
  height: 65px;
  ${({ $isSubscribeVisible }) =>
    $isSubscribeVisible &&
    "background: url(images/lib/header-subscribe-bg.svg) no-repeat center;"}

  .logo-position {
    display: flex;
    width: 100%;
    gap: 50.1%;
  }

  .btn-subscribe {
    height: 51px;
    width: 210px;
    border-radius: 10px;
    background: #4974f6;
    color: #fff !important;
    border: none;
    font-size: 18px;
    position: absolute;
    left: calc(50% - 105px);
  }
`;

const CalendarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  span {
    text-transform: uppercase;
    color: #818292;
    font-size: 16px;
  }
`;

const SmartSearchTrigger = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5px;
  .btn-open {
    cursor: pointer;
    margin-bottom: 2px;
    //for gate
    margin-right: -12px;

    &:hover {
      opacity: 0.8;
    }
  }
`;

const StyledAnimatedLogoPlaceholder = styled.div`
  width: 92px;
`;

const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  font-size: 15px;
  transform: rotate(90deg);
  cursor: pointer;
  margin-bottom: 2px;
  // margin-right: -12px;

  &:hover {
    opacity: 0.8;
  }
`;

const StyledGateIcon = styled.div<{
  isSmartSearchVisible: boolean;
  isResponseVisible: boolean;
}>`
  font-size: 45px;
  display: flex;
  align-items: center;
  margin-left: 12px;
  // height={isSmartSearchVisible ? 77 : 55}
  // width={isSmartSearchVisible ? 48 : 40}
  font-size: ${({ isSmartSearchVisible, isResponseVisible }) =>
    isSmartSearchVisible && isResponseVisible
      ? "45px"
      : isSmartSearchVisible && !isResponseVisible
        ? "60px"
        : "50px"};
  ${({ isSmartSearchVisible }) => !isSmartSearchVisible && "cursor: pointer;"}
  margin-bottom: 2px;
  // margin-right: -12px;
`;
